import React, { useRef, useEffect, memo, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { play, pause } from 'lib/videoControls'

import { desktop } from 'styles/config/_breakpoints.scss'

import { CURSOR_ICONS } from 'components/ui/Cursor'
import CursorHover from 'components/ui/CursorHover'
import Video from 'components/ui/Video'

import s from './OriginalThumbnail.module.scss'
const cn = classNames.bind(s)

const OriginalThumbnail = ({
  portraitImage,
  landscapeImage,
  landscapeVideoMP4,
  landscapeVideoWEBM,
  alt,
  isActive,
  defaultThumbnail,
  autoplay = false,
}) => {
  const videoRef = useRef()
  const image = useMemo(() => (defaultThumbnail === 'portrait' ? portraitImage : landscapeImage), [defaultThumbnail])
  const [desktopBreakpoint, setDesktopBreakpoint] = useState(null)

  useEffect(() => {
    if (!videoRef.current) return
    isActive ? play(videoRef.current) : pause(videoRef.current)
  }, [isActive, videoRef])

  useEffect(() => setDesktopBreakpoint(parseInt(desktop)), [desktop])

  return (
    <div className={cn('thumbnail')}>
      <CursorHover icon={CURSOR_ICONS.VIDEO_CONTROLS_PLAY}>
        <div className={cn('media')}>
          {(portraitImage || landscapeImage) && (
            <picture alt={alt || landscapeImage.alt || 'work thumbnail'} className={cn('picture')}>
              {landscapeImage && <source media={`(min-width: ${desktopBreakpoint}px)`} srcSet={landscapeImage} />}
              <img src={image} alt={alt || image || 'work thumbnail'} style={{ height: '100%', width: '100%' }} />
            </picture>
          )}
          {(landscapeVideoWEBM || landscapeVideoMP4) && (
            <Video
              className={cn('video')}
              mp4={landscapeVideoMP4?.url || null}
              webm={landscapeVideoWEBM?.url || null}
              ref={videoRef}
              autoplay={autoplay}
            />
          )}
        </div>
      </CursorHover>
    </div>
  )
}

OriginalThumbnail.propTypes = {
  portraitImage: PropTypes.string,
  landscapeImage: PropTypes.string,
  landscapeVideoWEBM: PropTypes.object,
  landscapeVideoMP4: PropTypes.object,
  alt: PropTypes.string,
  isActive: PropTypes.bool,
  autoplay: PropTypes.bool,
  defaultThumbnail: PropTypes.oneOf(['landscape', 'portrait']),
}

export default memo(OriginalThumbnail)
